import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../../services/authService';
import {UserMessageService} from '../../../services/userMessageService';
import {EnvironmentService} from '../../../services/environmentService';
import { PaymentWhiteLabelAdminAPI } from '../../../services/wladmin/paymentWhiteLabelAdminAPI';

@inject(AuthService, UserMessageService, Router, PaymentWhiteLabelAdminAPI, EnvironmentService)
export class WhiteLabelInvoicesPrint {
    constructor(authService, userMessageService, router, api, envService) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.api = api;


    }

    activate(params) {
        this.dataList = null;
        this.sortBy = params.sortBy;
        this.sortDir = params.sortDir;
        this.id = params.id;

        this.load();


    }

    load() {
        this.api.getInvoiceList(
            null,
            null,
            this.sortBy,
            this.sortDir,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    saveLoadSuccess(data) {
        this.setData(data);

        setTimeout(() => {window.print();}, 1000);


    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData(data) {
        this.dataList = data.list;
        
    }


}
